import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AbstractToolWrapper} from 'app/tool-layer/class/tool-wrapper';
import {ComponentModule} from 'app/component/component.module';
import {NumberWallComponent} from 'app/tool-layer/tools/number-wall/number-wall.component';

@NgModule({
    imports: [CommonModule, ComponentModule],
    declarations: [NumberWallComponent],
    entryComponents: [NumberWallComponent],
    providers: [
        {
            provide: AbstractToolWrapper,
            useValue: AbstractToolWrapper.create(NumberWallComponent),
            multi: true,
        },
    ],
})
export class NumberWallModule {}
